"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NBSP = exports.RemoteConstants = void 0;
var app_1 = __importDefault(require("firebase/compat/app"));
require("firebase/compat/remote-config");
var environment_variables_1 = __importDefault(require("../utils/environment-variables"));
var ticket_1 = require("./ticket");
function lookup(key) {
    return environment_variables_1.default.lookupString(key);
}
function lookupBoolean(key) {
    return environment_variables_1.default.lookupBoolean(key);
}
function lookupNumber(key, radix) {
    return environment_variables_1.default.lookupNumber(key, radix);
}
var CONST_VARS;
(function (CONST_VARS) {
    CONST_VARS["REACT_APP_BASE_URL"] = "REACT_APP_BASE_URL";
    CONST_VARS["REACT_APP_AUTH_URL"] = "REACT_APP_AUTH_URL";
    CONST_VARS["REACT_APP_GATEWAY_V2"] = "REACT_APP_GATEWAY_V2";
    CONST_VARS["REACT_APP_TICKET_ENTRY_HISTORY_WITHOUT_MASK"] = "REACT_APP_TICKET_ENTRY_HISTORY_WITHOUT_MASK";
    CONST_VARS["REACT_APP_WEB_APP_URL"] = "REACT_APP_WEB_APP_URL";
    CONST_VARS["REACT_APP_CLIENT_ID"] = "REACT_APP_CLIENT_ID";
    CONST_VARS["REACT_APP_CLIENT_SECRET"] = "REACT_APP_CLIENT_SECRET";
    CONST_VARS["REACT_APP_GOOGLE_PLACES_API_KEY"] = "REACT_APP_GOOGLE_PLACES_API_KEY";
    CONST_VARS["REACT_APP_GOOGLE_PLACES_API_LANGUAGE"] = "REACT_APP_GOOGLE_PLACES_API_LANGUAGE";
    CONST_VARS["REACT_APP_CONSOLE_DEBUG"] = "REACT_APP_CONSOLE_DEBUG";
    CONST_VARS["REACT_APP_LOTTERY_TIME_ZONE"] = "REACT_APP_LOTTERY_TIME_ZONE";
    CONST_VARS["REACT_APP_LOTTERY_ID"] = "REACT_APP_LOTTERY_ID";
    CONST_VARS["REACT_APP_FIELDS_VARIANT"] = "REACT_APP_FIELDS_VARIANT";
    CONST_VARS["REACT_APP_GAME_NUMBER_LENGTH"] = "REACT_APP_GAME_NUMBER_LENGTH";
    CONST_VARS["REACT_APP_BOOK_NUMBER_LENGTH"] = "REACT_APP_BOOK_NUMBER_LENGTH";
    CONST_VARS["REACT_APP_TICKET_NUMBER_LENGTH"] = "REACT_APP_TICKET_NUMBER_LENGTH";
    CONST_VARS["REACT_APP_VALIDATION_CODE_LENGTH"] = "REACT_APP_VALIDATION_CODE_LENGTH";
    CONST_VARS["REACT_APP_ENDING_GAME_PERIOD"] = "REACT_APP_ENDING_GAME_PERIOD";
    CONST_VARS["REACT_APP_NEW_GAME_PERIOD"] = "REACT_APP_NEW_GAME_PERIOD";
    CONST_VARS["REACT_APP_UPCOMING_GAME_PERIOD"] = "REACT_APP_UPCOMING_GAME_PERIOD";
    CONST_VARS["REACT_APP_NUM_RELATED_GAMES"] = "REACT_APP_NUM_RELATED_GAMES";
    CONST_VARS["REACT_APP_NUM_DRAW_ELIGIBLE_GAMES"] = "REACT_APP_NUM_DRAW_ELIGIBLE_GAMES";
    CONST_VARS["REACT_APP_DRAW_ENDING_SOON_PERIOD"] = "REACT_APP_DRAW_ENDING_SOON_PERIOD";
    CONST_VARS["REACT_APP_DRAW_NEW_PERIOD"] = "REACT_APP_DRAW_NEW_PERIOD";
    CONST_VARS["REACT_APP_SAMPLE_SCRATCH_TICKET_KEY"] = "REACT_APP_SAMPLE_SCRATCH_TICKET_KEY";
    CONST_VARS["REACT_APP_SAMPLE_DRAW_TICKET_KEY"] = "REACT_APP_SAMPLE_DRAW_TICKET_KEY";
    CONST_VARS["REACT_APP_SAMPLE_FAST_PLAY_TICKET_KEY"] = "REACT_APP_SAMPLE_FAST_PLAY_TICKET_KEY";
    CONST_VARS["REACT_APP_SAMPLE_DRAW_QUICK_DRAW_TICKET_KEY"] = "REACT_APP_SAMPLE_DRAW_QUICK_DRAW_TICKET_KEY";
    CONST_VARS["REACT_APP_REWARDS_MAXIMUM"] = "REACT_APP_REWARDS_MAXIMUM";
    CONST_VARS["REACT_APP_SAMPLE_QUICK_CARD_TICKET_KEY"] = "REACT_APP_SAMPLE_QUICK_CARD_TICKET_KEY";
    CONST_VARS["REACT_APP_HISTORY_FILTER_START_DAYS"] = "REACT_APP_HISTORY_FILTER_START_DAYS";
    CONST_VARS["REACT_APP_SESSION_TIMEOUT_IN_SECONDS"] = "REACT_APP_SESSION_TIMEOUT_IN_SECONDS";
    CONST_VARS["REACT_APP_GAMES_PER_PAGE"] = "REACT_APP_GAMES_PER_PAGE";
    CONST_VARS["REACT_APP_REWARDS_PER_PAGE"] = "REACT_APP_REWARDS_PER_PAGE";
    CONST_VARS["REACT_APP_DRAWS_PER_PAGE"] = "REACT_APP_DRAWS_PER_PAGE";
    CONST_VARS["REACT_APP_GAME_DRAWS_PER_PAGE"] = "REACT_APP_GAME_DRAWS_PER_PAGE";
    CONST_VARS["REACT_APP_DISABLE_SECOND_CHANCE_PAGINATION"] = "REACT_APP_DISABLE_SECOND_CHANCE_PAGINATION";
    CONST_VARS["REACT_APP_HISTORY_ITEMS_PER_PAGE"] = "REACT_APP_HISTORY_ITEMS_PER_PAGE";
    CONST_VARS["REACT_APP_PAST_DRAWS_PER_PAGE"] = "REACT_APP_PAST_DRAWS_PER_PAGE";
    CONST_VARS["REACT_APP_SHOW_PAGINATION_IN_REWARDS"] = "REACT_APP_SHOW_PAGINATION_IN_REWARDS";
    CONST_VARS["REACT_APP_HOME_SCREEN_FETCH_DRAW_INTERVAL"] = "REACT_APP_HOME_SCREEN_FETCH_DRAW_INTERVAL";
    CONST_VARS["REACT_APP_HOME_SCREEN_PROGRESSIVE_DRAW_COUNT"] = "REACT_APP_HOME_SCREEN_PROGRESSIVE_DRAW_COUNT";
    CONST_VARS["REACT_APP_HOME_SCREEN_DRAW_COUNT"] = "REACT_APP_HOME_SCREEN_DRAW_COUNT";
    CONST_VARS["REACT_APP_HOME_SCREEN_REWARD_COUNT"] = "REACT_APP_HOME_SCREEN_REWARD_COUNT";
    CONST_VARS["REACT_APP_HOME_SCREEN_EARN_ACTIVITIES_COUNT"] = "REACT_APP_HOME_SCREEN_EARN_ACTIVITIES_COUNT";
    CONST_VARS["REACT_APP_SHORT_LIST_COUNT"] = "REACT_APP_SHORT_LIST_COUNT";
    CONST_VARS["REACT_APP_DEFAULT_PAGE_TITLE"] = "REACT_APP_DEFAULT_PAGE_TITLE";
    CONST_VARS["REACT_APP_HOME_FEATURED_CONTENT_KEY"] = "REACT_APP_HOME_FEATURED_CONTENT_KEY";
    CONST_VARS["REACT_APP_INVITE_FRIENDS_ACTIVITY_KEY"] = "REACT_APP_INVITE_FRIENDS_ACTIVITY_KEY";
    CONST_VARS["REACT_APP_INVITE_ACCEPTED_ACTIVITY_KEY"] = "REACT_APP_INVITE_ACCEPTED_ACTIVITY_KEY";
    CONST_VARS["REACT_APP_POINTS_FORMAT"] = "REACT_APP_POINTS_FORMAT";
    CONST_VARS["REACT_APP_CURRENCY_FORMAT"] = "REACT_APP_CURRENCY_FORMAT";
    CONST_VARS["REACT_APP_CURRENCY_FORMAT_WITH_DECIMAL"] = "REACT_APP_CURRENCY_FORMAT_WITH_DECIMAL";
    CONST_VARS["REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY"] = "REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY";
    CONST_VARS["REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY_V2"] = "REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY_V2";
    CONST_VARS["REACT_APP_INTERESTS_SURVEY_ACTIVITY_KEY"] = "REACT_APP_INTERESTS_SURVEY_ACTIVITY_KEY";
    CONST_VARS["REACT_APP_INTERESTS_SURVEY_SURVEY_ID"] = "REACT_APP_INTERESTS_SURVEY_SURVEY_ID";
    CONST_VARS["REACT_APP_DATE_FORMAT"] = "REACT_APP_DATE_FORMAT";
    CONST_VARS["REACT_APP_DEFAULT_DATE_FORMAT"] = "REACT_APP_DEFAULT_DATE_FORMAT";
    CONST_VARS["REACT_APP_DATE_TIME_FORMAT"] = "REACT_APP_DATE_TIME_FORMAT";
    CONST_VARS["REACT_APP_GOOGLE_ANALYTICS_CODE"] = "REACT_APP_GOOGLE_ANALYTICS_CODE";
    CONST_VARS["REACT_APP_GOOGLE_ANALYTICS_DEBUG"] = "REACT_APP_GOOGLE_ANALYTICS_DEBUG";
    CONST_VARS["REACT_APP_GOOGLE_TAG_MANAGER_ID"] = "REACT_APP_GOOGLE_TAG_MANAGER_ID";
    CONST_VARS["REACT_APP_FACEBOOK_APP_ID"] = "REACT_APP_FACEBOOK_APP_ID";
    CONST_VARS["REACT_APP_FACEBOOK_PIXEL_ID"] = "REACT_APP_FACEBOOK_PIXEL_ID";
    CONST_VARS["REACT_APP_HOME_PROMO_CODE_ACTIVITY_KEY"] = "REACT_APP_HOME_PROMO_CODE_ACTIVITY_KEY";
    CONST_VARS["REACT_APP_INSTAGRAM_CLIENT_ID"] = "REACT_APP_INSTAGRAM_CLIENT_ID";
    CONST_VARS["REACT_APP_PHONE_MASK"] = "REACT_APP_PHONE_MASK";
    CONST_VARS["REACT_APP_ABOUT_US_PAGE"] = "REACT_APP_ABOUT_US_PAGE";
    CONST_VARS["REACT_APP_FAQ_PAGE"] = "REACT_APP_FAQ_PAGE";
    CONST_VARS["REACT_APP_TERMS_PAGE"] = "REACT_APP_TERMS_PAGE";
    CONST_VARS["REACT_APP_TERMS_PAGE_LL"] = "REACT_APP_TERMS_PAGE_LL";
    CONST_VARS["REACT_APP_FAQ_PAGE_LL"] = "REACT_APP_FAQ_PAGE_LL";
    CONST_VARS["REACT_APP_PRIVACY_PAGE"] = "REACT_APP_PRIVACY_PAGE";
    CONST_VARS["REACT_APP_LOTTERY_URL"] = "REACT_APP_LOTTERY_URL";
    CONST_VARS["REACT_APP_PAST_REWARDS_PER_PAGE"] = "REACT_APP_PAST_REWARDS_PER_PAGE";
    CONST_VARS["REACT_APP_INSTANT_GAMES_TYPE_ID"] = "REACT_APP_INSTANT_GAMES_TYPE_ID";
    CONST_VARS["REACT_APP_HIDE_REWARDS_CATEGORIES"] = "REACT_APP_HIDE_REWARDS_CATEGORIES";
    CONST_VARS["REACT_APP_DEFAULT_GAME_TYPE"] = "REACT_APP_DEFAULT_GAME_TYPE";
    CONST_VARS["REACT_APP_SHOW_GAME_TYPE_FILTER"] = "REACT_APP_SHOW_GAME_TYPE_FILTER";
    CONST_VARS["REACT_APP_SHOW_DRAW_DATE"] = "REACT_APP_SHOW_DRAW_DATE";
    CONST_VARS["REACT_APP_COUPON_BACKGROUND"] = "REACT_APP_COUPON_BACKGROUND";
    CONST_VARS["REACT_APP_SHOW_USER_POINTS"] = "REACT_APP_SHOW_USER_POINTS";
    CONST_VARS["REACT_APP_SHOW_REWARD_TYPE_COLUMN"] = "REACT_APP_SHOW_REWARD_TYPE_COLUMN";
    CONST_VARS["REACT_APP_HIDE_REWARDS_INFO"] = "REACT_APP_HIDE_REWARDS_INFO";
    CONST_VARS["REACT_APP_SHOW_REWARD_COLUMN"] = "REACT_APP_SHOW_REWARD_COLUMN";
    CONST_VARS["REACT_APP_INTERESTS_SURVEY_IS_LEGACY"] = "REACT_APP_INTERESTS_SURVEY_IS_LEGACY";
    CONST_VARS["REACT_APP_BASE_IMAGE_URL"] = "REACT_APP_BASE_IMAGE_URL";
    CONST_VARS["REACT_APP_REWARD_CATEGORIES_SORTING"] = "REACT_APP_REWARD_CATEGORIES_SORTING";
    CONST_VARS["REACT_APP_ADDRESS_URL"] = "REACT_APP_ADDRESS_URL";
    CONST_VARS["REACT_APP_PROMOTIONS_EMAIL_OPT_IN_ACTIVITY_KEY"] = "REACT_APP_PROMOTIONS_EMAIL_OPT_IN_ACTIVITY_KEY";
    CONST_VARS["REACT_APP_JACKPOT_RESULTS_PER_PAGE"] = "REACT_APP_JACKPOT_RESULTS_PER_PAGE";
    CONST_VARS["REACT_APP_PROMO_COMING_SOON_PERIOD"] = "REACT_APP_PROMO_COMING_SOON_PERIOD";
    CONST_VARS["REACT_APP_SHOW_CONTACT_INFO"] = "REACT_APP_SHOW_CONTACT_INFO";
    CONST_VARS["REACT_APP_FEATURES"] = "REACT_APP_FEATURES";
    CONST_VARS["REACT_APP_ARCADE_GAME_TYPE"] = "REACT_APP_ARCADE_GAME_TYPE";
    CONST_VARS["REACT_APP_SHOW_TICKETCARDVIEW"] = "REACT_APP_SHOW_TICKETCARDVIEW";
    CONST_VARS["REACT_APP_SHOW_TICKETDISCLAIMER"] = "REACT_APP_SHOW_TICKETDISCLAIMER";
    CONST_VARS["REACT_APP_ARCADE_WAGER_DEFAULT_INDEX"] = "REACT_APP_ARCADE_WAGER_DEFAULT_INDEX";
    CONST_VARS["REACT_APP_REDEEM_TOKENS_REWARD"] = "REACT_APP_REDEEM_TOKENS_REWARD";
    CONST_VARS["REACT_APP_REDEEM_TOKENS_ACTIVITY"] = "REACT_APP_REDEEM_TOKENS_ACTIVITY";
    CONST_VARS["REACT_APP_REDEEM_DAILY_BONUS_ACTIVITY"] = "REACT_APP_REDEEM_DAILY_BONUS_ACTIVITY";
    CONST_VARS["REACT_APP_LUCKY_LOUNGE_WEB_IMAGE"] = "REACT_APP_LUCKY_LOUNGE_WEB_IMAGE_URL";
    CONST_VARS["REACT_APP_LUCKY_LOUNGE_MOBILE_IMAGE"] = "REACT_APP_LUCKY_LOUNGE_MOBILE_IMAGE_URL";
    CONST_VARS["REACT_APP_NGL_BASE_URL"] = "REACT_APP_NGL_BASE_URL";
    CONST_VARS["REACT_APP_UPLOAD_PHOTO_IMAGE_SIZE"] = "REACT_APP_UPLOAD_PHOTO_IMAGE_SIZE";
    CONST_VARS["REACT_APP_IOS_DOWNLOAD_URL"] = "REACT_APP_IOS_DOWNLOAD_URL";
    CONST_VARS["REACT_APP_ANDROID_DOWNLOAD_URL"] = "REACT_APP_ANDROID_DOWNLOAD_URL";
    CONST_VARS["REACT_APP_INFORMATION_ONLY_WEB_IMAGE"] = "REACT_APP_INFORMATION_ONLY_WEB_IMAGE_URL";
    CONST_VARS["REACT_APP_INFORMATION_ONLY_MOBILE_IMAGE"] = "REACT_APP_INFORMATION_ONLY_MOBILE_IMAGE_URL";
    CONST_VARS["REACT_APP_IDOLOGY_VERIFY_STATUS_POLLING_INTERVAL"] = "REACT_APP_IDOLOGY_VERIFY_STATUS_POLLING_INTERVAL";
    CONST_VARS["REACT_APP_SHOW_COUPON_SOLD_OUT_BANNER"] = "REACT_APP_SHOW_COUPON_SOLD_OUT_BANNER";
    CONST_VARS["REACT_APP_LOTTERY"] = "REACT_APP_LOTTERY";
    CONST_VARS["REACT_APP_DESIGN_TYPE"] = "REACT_APP_DESIGN_TYPE";
    CONST_VARS["REACT_APP_GAME_SUPPLIER"] = "REACT_APP_GAME_SUPPLIER";
    CONST_VARS["REACT_APP_GAME_DEVELOPER"] = "REACT_APP_GAME_DEVELOPER";
    CONST_VARS["REACT_APP_TICKET_TYPE"] = "REACT_APP_TICKET_TYPE";
    CONST_VARS["REACT_APP_ACTION_EMITTER_PLAYER"] = "REACT_APP_ACTION_EMITTER_PLAYER";
    CONST_VARS["REACT_APP_GAME_ENGINE"] = "REACT_APP_GAME_ENGINE";
    CONST_VARS["REACT_APP_ORIENTATION"] = "REACT_APP_ORIENTATION";
    CONST_VARS["REACT_APP_GAME_TYPE"] = "REACT_APP_GAME_TYPE";
    CONST_VARS["REACT_APP_IN_GAME_EVENT"] = "REACT_APP_IN_GAME_EVENT";
    CONST_VARS["REACT_APP_SHOW_DIGITAL_SUMMARY_AT_END"] = "REACT_APP_SHOW_DIGITAL_SUMMARY_AT_END";
    CONST_VARS["REACT_APP_SHOW_TITLE_ABOVE_IMAGE"] = "REACT_APP_SHOW_TITLE_ABOVE_IMAGE";
    CONST_VARS["REACT_APP_SHOW_SUPER_BONUS_DIALOG"] = "REACT_APP_SHOW_SUPER_BONUS_DIALOG";
    CONST_VARS["REACT_APP_SHOW_BONUS_POINTS"] = "REACT_APP_SHOW_BONUS_POINTS";
    CONST_VARS["REACT_APP_SECOND_CHANCE_ONLY"] = "REACT_APP_SECOND_CHANCE_ONLY";
    CONST_VARS["REACT_APP_SECOND_CHANCE_V2"] = "REACT_APP_SECOND_CHANCE_V2";
    CONST_VARS["REACT_APP_DISABLE_DRAWS_CORNER_ICON"] = "REACT_APP_DISABLE_DRAWS_CORNER_ICON";
    CONST_VARS["REACT_APP_DISABLE_REWARDS_CORNER_ICON"] = "REACT_APP_DISABLE_REWARDS_CORNER_ICON";
    CONST_VARS["REACT_APP_MIN_UNCLAIMED_PRIZE_LIMIT"] = "REACT_APP_MIN_UNCLAIMED_PRIZE_LIMIT";
    CONST_VARS["REACT_APP_DEFAULT_COUNTRY_CODE"] = "REACT_APP_DEFAULT_COUNTRY_CODE";
    CONST_VARS["REACT_APP_DEFAULT_STATE_CODE"] = "REACT_APP_DEFAULT_STATE_CODE";
    CONST_VARS["REACT_APP_DEFAULT_STATE_NAME"] = "REACT_APP_DEFAULT_STATE_NAME";
    CONST_VARS["REACT_APP_SKIP_GENDER"] = "REACT_APP_SKIP_GENDER";
    CONST_VARS["REACT_APP_V2_CHANGES"] = "REACT_APP_V2_CHANGES";
    CONST_VARS["REWARD_TYPES"] = "REACT_APP_REWARD_TYPES";
    CONST_VARS["REACT_APP_CHECK_FOR_WINNER_DETAILS"] = "REACT_APP_CHECK_FOR_WINNER_DETAILS";
    CONST_VARS["REACT_APP_MESSAGE_BAR_TIMEOUT_TICKET_SCREEN"] = "REACT_APP_MESSAGE_BAR_TIMEOUT_TICKET_SCREEN";
    CONST_VARS["REACT_APP_KS_BASE_URL"] = "REACT_APP_KS_BASE_URL";
    CONST_VARS["REACT_APP_RESET_FIELDS_AFTER_SUBMIT_TICKET"] = "REACT_APP_RESET_FIELDS_AFTER_SUBMIT_TICKET";
    CONST_VARS["REACT_APP_IS_RESTRICTION_ENABLED"] = "REACT_APP_IS_RESTRICTION_ENABLED";
    CONST_VARS["REACT_APP_HIDE_MATERIAL_UI_STICKY_LABEL"] = "REACT_APP_HIDE_MATERIAL_UI_STICKY_LABEL";
    CONST_VARS["REACT_APP_REMOVE_SECOND_CHANCE_TAB_FILTER"] = "REACT_APP_REMOVE_SECOND_CHANCE_TAB_FILTER";
    CONST_VARS["REACT_APP_WITH_BUTTON_ICON"] = "REACT_APP_WITH_BUTTON_ICON";
    CONST_VARS["REACT_APP_HIDE_MESSAGE_BAR"] = "REACT_APP_HIDE_MESSAGE_BAR";
    CONST_VARS["REACT_APP_CUSTOM_HOME_URL"] = "REACT_APP_CUSTOM_HOME_URL";
    CONST_VARS["REACT_APP_CUSTOM_CONTACT_US_URL"] = "REACT_APP_CUSTOM_CONTACT_US_URL";
    CONST_VARS["REACT_APP_CUSTOM_LOGIN_URL"] = "REACT_APP_CUSTOM_LOGIN_URL";
    CONST_VARS["REACT_APP_USE_JACKPOT_SERVICE_KENO"] = "REACT_APP_USE_JACKPOT_SERVICE_KENO";
    CONST_VARS["REACT_APP_KENO_GAME_URL"] = "REACT_APP_KENO_GAME_URL";
    CONST_VARS["REACT_APP_PADDED_ZEROS_LENGTH"] = "REACT_APP_PADDED_ZEROS_LENGTH";
    CONST_VARS["REACT_APP_HOT_COLD_NUMBERS_DEFAULT_DRAWS"] = "REACT_APP_HOT_COLD_NUMBERS_DEFAULT_DRAWS";
    CONST_VARS["REACT_APP_HOT_AND_COLD_SELECT_ROUNDED"] = "REACT_APP_HOT_AND_COLD_SELECT_ROUNDED";
    CONST_VARS["REACT_APP_HOT_AND_COLD_SHOW_DROPDOWN"] = "REACT_APP_HOT_AND_COLD_SHOW_DROPDOWN";
    CONST_VARS["REACT_APP_IS_FETCH_DRAW_WINNERS_USING_DRAW_SERVICE"] = "REACT_APP_IS_FETCH_DRAW_WINNERS_USING_DRAW_SERVICE";
    CONST_VARS["REACT_APP_USA_ONLY_ZIPCODE"] = "REACT_APP_USA_ONLY_ZIPCODE";
    CONST_VARS["REACT_APP_SHOW_TRANSACTION_ID"] = "REACT_APP_SHOW_TRANSACTION_ID";
    CONST_VARS["REACT_APP_HIDE_REWARD_EARN_LIST_ICON"] = "REACT_APP_HIDE_REWARD_EARN_LIST_ICON";
    CONST_VARS["REACT_APP_SHOW_REWARD_CATEGORY_NAME"] = "REACT_APP_SHOW_REWARD_CATEGORY_NAME";
    CONST_VARS["REACT_APP_HIDE_DETAIL_TILE_CONTENT"] = "REACT_APP_HIDE_DETAIL_TILE_CONTENT";
    CONST_VARS["REACT_APP_TRIM_SQUARE_BRACKET_ACTIVITY_TITLE"] = "REACT_APP_TRIM_SQUARE_BRACKET_ACTIVITY_TITLE";
    CONST_VARS["REACT_APP_CHECK_TERMS_AND_CONDITIONS_ENABLED"] = "REACT_APP_CHECK_TERMS_AND_CONDITIONS_ENABLED";
    CONST_VARS["REACT_APP_SHOW_PENDING_POINTS_ON_HISTORY_PAGE"] = "REACT_APP_SHOW_PENDING_POINTS_ON_HISTORY_PAGE";
    CONST_VARS["REACT_APP_REFRESH_HISTORY_DATA_AFTER_GAMEPLAY"] = "REACT_APP_REFRESH_HISTORY_DATA_AFTER_GAMEPLAY";
    CONST_VARS["REACT_APP_HISTORY_WIDGET_PERSIST_SPINNER"] = "REACT_APP_HISTORY_WIDGET_PERSIST_SPINNER";
    CONST_VARS["REACT_APP_ACCESSIBLE_NUMBER_CHECKER_WIDGET"] = "REACT_APP_ACCESSIBLE_NUMBER_CHECKER_WIDGET";
    CONST_VARS["REACT_APP_PREFERENCES_MESSAGE_BAR_TIMEOUT_IN_MILLISECONDS"] = "REACT_APP_PREFERENCES_MESSAGE_BAR_TIMEOUT_IN_MILLISECONDS";
    CONST_VARS["REACT_APP_ACCESSIBLE_PREFERENCE_SWITCH"] = "REACT_APP_ACCESSIBLE_PREFERENCE_SWITCH";
    CONST_VARS["REACT_APP_HIDE_SUCCESS_FOR_PENDING_ENTRIES"] = "REACT_APP_HIDE_SUCCESS_FOR_PENDING_ENTRIES";
    CONST_VARS["REACT_APP_SHOULD_NOT_SHOW_GAME_ID"] = "REACT_APP_SHOULD_NOT_SHOW_GAME_ID";
    CONST_VARS["REACT_APP_FASTPLAY_MANUAL_ENTRY"] = "REACT_APP_FASTPLAY_MANUAL_ENTRY";
    CONST_VARS["REACT_APP_FASTPLAY_GAMETYPE_ID"] = "REACT_APP_FASTPLAY_GAMETYPE_ID";
})(CONST_VARS || (CONST_VARS = {}));
var constants = {
    BASE_URL: lookup(CONST_VARS.REACT_APP_BASE_URL),
    AUTH_URL: lookup(CONST_VARS.REACT_APP_AUTH_URL),
    GATEWAY_V2: lookupBoolean(CONST_VARS.REACT_APP_GATEWAY_V2),
    SHOW_TICKET_ENTRY_HISTORY_WITHOUT_MASK: lookupBoolean(CONST_VARS.REACT_APP_TICKET_ENTRY_HISTORY_WITHOUT_MASK),
    WEB_APP_URL: lookup(CONST_VARS.REACT_APP_WEB_APP_URL),
    CLIENT_ID: lookup(CONST_VARS.REACT_APP_CLIENT_ID),
    CLIENT_SECRET: lookup(CONST_VARS.REACT_APP_CLIENT_SECRET),
    GOOGLE_PLACES_API_KEY: lookup(CONST_VARS.REACT_APP_GOOGLE_PLACES_API_KEY),
    GOOGLE_PLACES_API_LANGUAGE: lookup(CONST_VARS.REACT_APP_GOOGLE_PLACES_API_LANGUAGE),
    CONSOLE_DEBUG: lookupBoolean(CONST_VARS.REACT_APP_CONSOLE_DEBUG),
    LOTTERY_TIME_ZONE: lookup(CONST_VARS.REACT_APP_LOTTERY_TIME_ZONE),
    LOTTERY_ID: lookupNumber(CONST_VARS.REACT_APP_LOTTERY_ID, 10),
    FIELDS_VARIANT: lookup(CONST_VARS.REACT_APP_FIELDS_VARIANT),
    GAME_NUMBER_LENGTH: lookupNumber(CONST_VARS.REACT_APP_GAME_NUMBER_LENGTH, 10),
    BOOK_NUMBER_LENGTH: lookupNumber(CONST_VARS.REACT_APP_BOOK_NUMBER_LENGTH, 10),
    TICKET_NUMBER_LENGTH: lookupNumber(CONST_VARS.REACT_APP_TICKET_NUMBER_LENGTH, 10),
    VALIDATION_CODE_LENGTH: lookupNumber(CONST_VARS.REACT_APP_VALIDATION_CODE_LENGTH, 10),
    ENDING_GAME_PERIOD: lookupNumber(CONST_VARS.REACT_APP_ENDING_GAME_PERIOD, 10),
    NEW_GAME_PERIOD: lookupNumber(CONST_VARS.REACT_APP_NEW_GAME_PERIOD, 10),
    UPCOMING_GAME_PERIOD: lookupNumber(CONST_VARS.REACT_APP_UPCOMING_GAME_PERIOD, 10),
    NUM_RELATED_GAMES: lookupNumber(CONST_VARS.REACT_APP_NUM_RELATED_GAMES, 10),
    NUM_DRAW_ELIGIBLE_GAMES: lookupNumber(CONST_VARS.REACT_APP_NUM_DRAW_ELIGIBLE_GAMES, 10),
    DRAW_NEW_PERIOD: lookupNumber(CONST_VARS.REACT_APP_DRAW_NEW_PERIOD, 10),
    DRAW_ENDING_SOON_PERIOD: lookupNumber(CONST_VARS.REACT_APP_DRAW_ENDING_SOON_PERIOD, 10),
    SAMPLE_SCRATCH_TICKET_KEY: lookup(CONST_VARS.REACT_APP_SAMPLE_SCRATCH_TICKET_KEY),
    SAMPLE_FAST_PLAY_TICKET_KEY: lookup(CONST_VARS.REACT_APP_SAMPLE_FAST_PLAY_TICKET_KEY),
    SAMPLE_DRAW_TICKET_KEY: lookup(CONST_VARS.REACT_APP_SAMPLE_DRAW_TICKET_KEY),
    SAMPLE_DRAW_QUICK_DRAW_TICKET_KEY: lookup(CONST_VARS.REACT_APP_SAMPLE_DRAW_QUICK_DRAW_TICKET_KEY),
    SAMPLE_QUICK_CARD_TICKET_KEY: lookup(CONST_VARS.REACT_APP_SAMPLE_QUICK_CARD_TICKET_KEY),
    REWARDS_MAXIMUM: lookupNumber(CONST_VARS.REACT_APP_REWARDS_MAXIMUM, 10),
    HISTORY_FILTER_START_DAYS: lookupNumber(CONST_VARS.REACT_APP_HISTORY_FILTER_START_DAYS, 10),
    SESSION_TIMEOUT_IN_SECONDS: lookupNumber(CONST_VARS.REACT_APP_SESSION_TIMEOUT_IN_SECONDS, 10),
    GAMES_PER_PAGE: lookupNumber(CONST_VARS.REACT_APP_GAMES_PER_PAGE, 10),
    REWARDS_PER_PAGE: lookupNumber(CONST_VARS.REACT_APP_REWARDS_PER_PAGE, 10),
    DRAWS_PER_PAGE: lookupNumber(CONST_VARS.REACT_APP_DRAWS_PER_PAGE, 10),
    GAME_DRAWS_PER_PAGE: lookupNumber(CONST_VARS.REACT_APP_GAME_DRAWS_PER_PAGE, 10),
    HISTORY_ITEMS_PER_PAGE: lookupNumber(CONST_VARS.REACT_APP_HISTORY_ITEMS_PER_PAGE, 25),
    NCEL_BASE_URL: process.env.REACT_APP_NCEL_BASE_URL,
    KENO_GAME_URL: lookup(CONST_VARS.REACT_APP_KENO_GAME_URL),
    KENO_ID: parseInt(process.env.REACT_APP_KENO_ID, 10),
    KENO_POLLING_INTERVAL: parseInt(process.env.REACT_APP_KENO_POLLING_INTERVAL_IN_MS, 10),
    KENO_TIMOUT_BUFFER: parseInt(process.env.REACT_APP_KENO_TIMOUT_BUFFER, 10),
    KENO_AUTOPLAY_DELAY: parseInt(process.env.REACT_APP_KENO_AUTOPLAY_DELAY_IN_MS, 10),
    KENO_AUTOPLAY: process.env.REACT_APP_KENO_AUTOPLAY === 'true',
    SHOW_SIGN_IN_WARNING: process.env.REACT_APP_SHOW_SIGN_IN_WARNING === 'true',
    HOT_COLD_NUMBERS_DEFAULT_DRAWS: lookupNumber(CONST_VARS.REACT_APP_HOT_COLD_NUMBERS_DEFAULT_DRAWS, 10),
    HOT_AND_COLD_SELECT_ROUNDED: lookupBoolean(CONST_VARS.REACT_APP_HOT_AND_COLD_SELECT_ROUNDED),
    HOT_AND_COLD_SHOW_DROPDOWN: lookupBoolean(CONST_VARS.REACT_APP_HOT_AND_COLD_SHOW_DROPDOWN),
    HOT_AND_COLD_DROPDOWN_OPTIONS: '10,20,50,100',
    PAST_DRAWS_PER_PAGE: lookupNumber(CONST_VARS.REACT_APP_PAST_DRAWS_PER_PAGE, 10),
    SHOW_PAGINATION_IN_REWARDS: lookupBoolean(CONST_VARS.REACT_APP_SHOW_PAGINATION_IN_REWARDS),
    MIN_UNCLAIMED_PRIZE_LIMIT: lookupNumber(CONST_VARS.REACT_APP_MIN_UNCLAIMED_PRIZE_LIMIT, 10),
    HOME_SCREEN_FETCH_DRAW_INTERVAL: lookupNumber(CONST_VARS.REACT_APP_HOME_SCREEN_FETCH_DRAW_INTERVAL, 10),
    HOME_SCREEN_PROGRESSIVE_DRAW_COUNT: lookupNumber(CONST_VARS.REACT_APP_HOME_SCREEN_PROGRESSIVE_DRAW_COUNT, 10),
    HOME_SCREEN_DRAW_COUNT: lookupNumber(CONST_VARS.REACT_APP_HOME_SCREEN_DRAW_COUNT, 10),
    HOME_SCREEN_REWARD_COUNT: lookupNumber(CONST_VARS.REACT_APP_HOME_SCREEN_REWARD_COUNT, 10),
    HOME_SCREEN_EARN_ACTIVITIES_COUNT: lookupNumber(CONST_VARS.REACT_APP_HOME_SCREEN_EARN_ACTIVITIES_COUNT, 10),
    SHORT_LIST_COUNT: lookupNumber(CONST_VARS.REACT_APP_SHORT_LIST_COUNT, 10),
    DEFAULT_PAGE_TITLE: lookup(CONST_VARS.REACT_APP_DEFAULT_PAGE_TITLE),
    HOME_FEATURED_CONTENT_KEY: lookup(CONST_VARS.REACT_APP_HOME_FEATURED_CONTENT_KEY),
    INVITE_FRIENDS_ACTIVITY_KEY: lookup(CONST_VARS.REACT_APP_INVITE_FRIENDS_ACTIVITY_KEY),
    INVITE_ACCEPTED_ACTIVITY_KEY: lookup(CONST_VARS.REACT_APP_INVITE_ACCEPTED_ACTIVITY_KEY),
    POINTS_FORMAT: lookup(CONST_VARS.REACT_APP_POINTS_FORMAT),
    CURRENCY_FORMAT: lookup(CONST_VARS.REACT_APP_CURRENCY_FORMAT),
    CURRENCY_FORMAT_WITH_DECIMAL: lookup(CONST_VARS.REACT_APP_CURRENCY_FORMAT_WITH_DECIMAL),
    GOOGLE_RECAPTCHA_SITE_KEY: lookup(CONST_VARS.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY),
    GOOGLE_RECAPTCHA_SITE_KEY_V2: lookup(CONST_VARS.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY_V2),
    INTERESTS_SURVEY: {
        ACTIVITY_KEY: lookup(CONST_VARS.REACT_APP_INTERESTS_SURVEY_ACTIVITY_KEY),
        SURVEY_ID: lookup(CONST_VARS.REACT_APP_INTERESTS_SURVEY_SURVEY_ID)
    },
    DATE_FORMAT: lookup(CONST_VARS.REACT_APP_DATE_FORMAT),
    DEFAULT_DATE_FORMAT: lookup(CONST_VARS.REACT_APP_DEFAULT_DATE_FORMAT),
    DATE_TIME_FORMAT: lookup(CONST_VARS.REACT_APP_DATE_TIME_FORMAT),
    GOOGLE_ANALYTICS_CODE: lookup(CONST_VARS.REACT_APP_GOOGLE_ANALYTICS_CODE),
    GOOGLE_ANALYTICS_DEBUG: lookupBoolean(CONST_VARS.REACT_APP_GOOGLE_ANALYTICS_DEBUG),
    GOOGLE_TAG_MANAGER_ID: lookup(CONST_VARS.REACT_APP_GOOGLE_TAG_MANAGER_ID),
    FACEBOOK_APP_ID: lookup(CONST_VARS.REACT_APP_FACEBOOK_APP_ID),
    FACEBOOK_PIXEL_ID: lookup(CONST_VARS.REACT_APP_FACEBOOK_PIXEL_ID),
    HOME_PROMO_CODE_ACTIVITY_KEY: lookup(CONST_VARS.REACT_APP_HOME_PROMO_CODE_ACTIVITY_KEY),
    MEDIA_API: '/media/api/file/',
    INSTAGRAM_CLIENT_ID: lookup(CONST_VARS.REACT_APP_INSTAGRAM_CLIENT_ID),
    PHONE_MASK: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    ABOUT_US_PAGE: lookup(CONST_VARS.REACT_APP_ABOUT_US_PAGE),
    FAQ_PAGE: lookup(CONST_VARS.REACT_APP_FAQ_PAGE),
    FAQ_PAGE_LL: lookup(CONST_VARS.REACT_APP_FAQ_PAGE_LL),
    TERMS_PAGE: lookup(CONST_VARS.REACT_APP_TERMS_PAGE),
    TERMS_PAGE_LL: lookup(CONST_VARS.REACT_APP_TERMS_PAGE_LL),
    PRIVACY_PAGE: lookup(CONST_VARS.REACT_APP_PRIVACY_PAGE),
    LOTTERY_URL: lookup(CONST_VARS.REACT_APP_LOTTERY_URL),
    PAST_REWARDS_PER_PAGE: lookupNumber(CONST_VARS.REACT_APP_PAST_REWARDS_PER_PAGE, 10),
    INSTANT_GAMES_TYPE_ID: lookupNumber(CONST_VARS.REACT_APP_INSTANT_GAMES_TYPE_ID, 10),
    HIDE_REWARDS_CATEGORIES: lookupBoolean(CONST_VARS.REACT_APP_HIDE_REWARDS_CATEGORIES),
    DISABLE_SECOND_CHANCE_PAGINATION: lookupBoolean(CONST_VARS.REACT_APP_DISABLE_SECOND_CHANCE_PAGINATION),
    DEFAULT_GAME_TYPE: lookup(CONST_VARS.REACT_APP_DEFAULT_GAME_TYPE),
    SHOW_GAME_TYPE_FILTER: lookupBoolean(CONST_VARS.REACT_APP_SHOW_GAME_TYPE_FILTER),
    SHOW_DRAW_DATE: lookupBoolean(CONST_VARS.REACT_APP_SHOW_DRAW_DATE),
    COUPON_BACKGROUND: lookup(CONST_VARS.REACT_APP_COUPON_BACKGROUND),
    SHOW_USER_POINTS: lookupBoolean(CONST_VARS.REACT_APP_SHOW_USER_POINTS),
    SHOW_REWARD_TYPE_COLUMN: lookupBoolean(CONST_VARS.REACT_APP_SHOW_REWARD_TYPE_COLUMN),
    HIDE_REWARDS_INFO: lookupBoolean(CONST_VARS.REACT_APP_HIDE_REWARDS_INFO),
    SHOW_REWARD_COLUMN: lookupBoolean(CONST_VARS.REACT_APP_SHOW_REWARD_COLUMN),
    SHOW_TITLE_ABOVE_IMAGE: lookupBoolean(CONST_VARS.REACT_APP_SHOW_TITLE_ABOVE_IMAGE),
    SHOW_SUPER_BONUS_DIALOG: lookupBoolean(CONST_VARS.REACT_APP_SHOW_SUPER_BONUS_DIALOG),
    SHOW_BONUS_POINTS: lookupBoolean(CONST_VARS.REACT_APP_SHOW_BONUS_POINTS),
    INTERESTS_SURVEY_IS_LEGACY: lookupBoolean(CONST_VARS.REACT_APP_INTERESTS_SURVEY_IS_LEGACY),
    BASE_IMAGE_URL: lookup(CONST_VARS.REACT_APP_BASE_IMAGE_URL),
    REWARD_CATEGORIES_SORTING: lookup(CONST_VARS.REACT_APP_REWARD_CATEGORIES_SORTING),
    ADDRESS_URL: lookup(CONST_VARS.REACT_APP_ADDRESS_URL),
    PROMOTIONS_EMAIL_OPT_IN_ACTIVITY_KEY: lookup(CONST_VARS.REACT_APP_PROMOTIONS_EMAIL_OPT_IN_ACTIVITY_KEY),
    JACKPOT_RESULTS_PER_PAGE: lookupNumber(CONST_VARS.REACT_APP_JACKPOT_RESULTS_PER_PAGE, 10),
    PROMO_COMING_SOON_PERIOD: lookupNumber(CONST_VARS.REACT_APP_PROMO_COMING_SOON_PERIOD, 10),
    SHOW_CONTACT_INFO: lookupBoolean(CONST_VARS.REACT_APP_SHOW_CONTACT_INFO),
    FEATURES: lookup(CONST_VARS.REACT_APP_FEATURES),
    ARCADE_GAME_TYPE: lookupNumber(CONST_VARS.REACT_APP_ARCADE_GAME_TYPE, 10),
    PAYSAFE_API_KEY: '',
    PAYSAFE_ENV: '',
    SHOW_TICKETCARDVIEW: lookupBoolean(CONST_VARS.REACT_APP_SHOW_TICKETCARDVIEW),
    SHOW_TICKETDISCLAIMER: lookupBoolean(CONST_VARS.REACT_APP_SHOW_TICKETDISCLAIMER),
    ARCADE_WAGER_DEFAULT_INDEX: lookupNumber(CONST_VARS.REACT_APP_ARCADE_WAGER_DEFAULT_INDEX, 10),
    REDEEM_TOKENS_REWARD: lookup(CONST_VARS.REACT_APP_REDEEM_TOKENS_REWARD),
    REDEEM_TOKENS_ACTIVITY: lookup(CONST_VARS.REACT_APP_REDEEM_TOKENS_ACTIVITY),
    REDEEM_DAILY_BONUS_ACTIVITY: lookup(CONST_VARS.REACT_APP_REDEEM_DAILY_BONUS_ACTIVITY),
    LUCKY_LOUNGE_WEB_IMAGE: lookup(CONST_VARS.REACT_APP_LUCKY_LOUNGE_WEB_IMAGE),
    LUCKY_LOUNGE_MOBILE_IMAGE: lookup(CONST_VARS.REACT_APP_LUCKY_LOUNGE_MOBILE_IMAGE),
    NGL_BASE_URL: lookup(CONST_VARS.REACT_APP_NGL_BASE_URL),
    QUICK_DRAW_SHOW_NEXT_DRAW_CONTAINER: true,
    UPLOAD_PHOTO_IMAGE_SIZE: lookupNumber(CONST_VARS.REACT_APP_UPLOAD_PHOTO_IMAGE_SIZE, 10),
    IOS_DOWNLOAD_URL: lookup(CONST_VARS.REACT_APP_IOS_DOWNLOAD_URL),
    ANDROID_DOWNLOAD_URL: lookup(CONST_VARS.REACT_APP_ANDROID_DOWNLOAD_URL),
    INFORMATION_ONLY_WEB_IMAGE: lookup(CONST_VARS.REACT_APP_INFORMATION_ONLY_WEB_IMAGE),
    INFORMATION_ONLY_MOBILE_IMAGE: lookup(CONST_VARS.REACT_APP_INFORMATION_ONLY_MOBILE_IMAGE),
    IDOLOGY_VERIFY_STATUS_POLLING_INTERVAL: lookupNumber(CONST_VARS.REACT_APP_IDOLOGY_VERIFY_STATUS_POLLING_INTERVAL, 10),
    SHOW_COUPON_SOLD_OUT_BANNER: lookupBoolean(CONST_VARS.REACT_APP_SHOW_COUPON_SOLD_OUT_BANNER),
    USE_PROMOTION_SERVICE_FOR_DRAW_HISTORY: false,
    USE_LOCAL_STORAGE_TO_LOGIN: true,
    LOTTERY: lookup(CONST_VARS.REACT_APP_LOTTERY),
    DESIGN_TYPE: lookup(CONST_VARS.REACT_APP_DESIGN_TYPE),
    GAME_SUPPLIER: lookup(CONST_VARS.REACT_APP_GAME_SUPPLIER),
    GAME_DEVELOPER: lookup(CONST_VARS.REACT_APP_GAME_DEVELOPER),
    TICKET_TYPE: lookup(CONST_VARS.REACT_APP_TICKET_TYPE),
    ACTION_EMITTER_PLAYER: lookup(CONST_VARS.REACT_APP_ACTION_EMITTER_PLAYER),
    GAME_ENGINE: lookup(CONST_VARS.REACT_APP_GAME_ENGINE),
    ORIENTATION: lookup(CONST_VARS.REACT_APP_ORIENTATION),
    GAME_TYPE: lookup(CONST_VARS.REACT_APP_GAME_TYPE),
    IN_GAME_EVENT: lookup(CONST_VARS.REACT_APP_IN_GAME_EVENT),
    OUTAGE_CONFIG: '{}',
    OUTAGE_BANNER_CONFIG: '{}',
    HOME_PAGE_DESCRIPTION: '{}',
    SHOW_DIGITAL_SUMMARY_AT_END: lookupBoolean(CONST_VARS.REACT_APP_SHOW_DIGITAL_SUMMARY_AT_END),
    SCRATCH_TICKET_BARCODE_MASK: [
        /[0-9]/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/
    ],
    SCRATCH_TICKET_VALIDATION_MASK: [
        /[0-9]/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/
    ],
    TICKET_TABS_DATA: (0, ticket_1.getTicketTab)(true),
    TICKET_HELP_DATA: ticket_1.helpTabs,
    SECOND_CHANCE_ONLY: lookupBoolean(CONST_VARS.REACT_APP_SECOND_CHANCE_ONLY),
    SECOND_CHANCE_V2: lookupBoolean(CONST_VARS.REACT_APP_SECOND_CHANCE_V2),
    DISABLE_DRAWS_CORNER_ICON: lookupBoolean(CONST_VARS.REACT_APP_DISABLE_DRAWS_CORNER_ICON),
    DISABLE_REWARDS_CORNER_ICON: lookupBoolean(CONST_VARS.REACT_APP_DISABLE_REWARDS_CORNER_ICON),
    DEFAULT_COUNTRY_CODE: lookup(CONST_VARS.REACT_APP_DEFAULT_COUNTRY_CODE),
    DEFAULT_STATE_CODE: lookup(CONST_VARS.REACT_APP_DEFAULT_STATE_CODE),
    DEFAULT_STATE_NAME: lookup(CONST_VARS.REACT_APP_DEFAULT_STATE_NAME),
    SKIP_GENDER: lookupBoolean(CONST_VARS.REACT_APP_SKIP_GENDER),
    V2_CHANGES: lookupBoolean(CONST_VARS.REACT_APP_V2_CHANGES),
    INVITE_FRIEND_URL: lookup(CONST_VARS.REACT_APP_KS_BASE_URL),
    REWARD_TYPES: lookup(CONST_VARS.REWARD_TYPES),
    CHECK_FOR_WINNER_DETAILS: lookupBoolean(CONST_VARS.REACT_APP_CHECK_FOR_WINNER_DETAILS),
    MESSAGE_BAR_TIMEOUT_TICKET_SCREEN: lookupNumber(CONST_VARS.REACT_APP_MESSAGE_BAR_TIMEOUT_TICKET_SCREEN, 10),
    RESET_FIELDS_AFTER_SUBMIT_TICKET: lookupBoolean(CONST_VARS.REACT_APP_RESET_FIELDS_AFTER_SUBMIT_TICKET),
    IS_RESTRICTION_ENABLED: lookupBoolean(CONST_VARS.REACT_APP_IS_RESTRICTION_ENABLED),
    HIDE_MATERIAL_UI_STICKY_LABEL: lookupBoolean(CONST_VARS.REACT_APP_HIDE_MATERIAL_UI_STICKY_LABEL),
    REMOVE_SECOND_CHANCE_TAB_FILTER: lookupBoolean(CONST_VARS.REACT_APP_REMOVE_SECOND_CHANCE_TAB_FILTER),
    WITH_BUTTON_ICON: lookupBoolean(CONST_VARS.REACT_APP_WITH_BUTTON_ICON),
    HIDE_MESSAGE_BAR: lookupBoolean(CONST_VARS.REACT_APP_HIDE_MESSAGE_BAR),
    CUSTOM_HOME_URL: lookup(CONST_VARS.REACT_APP_CUSTOM_HOME_URL),
    CUSTOM_CONTACT_US_URL: lookup(CONST_VARS.REACT_APP_CUSTOM_CONTACT_US_URL),
    CUSTOM_LOGIN_URL: lookup(CONST_VARS.REACT_APP_CUSTOM_LOGIN_URL),
    USE_JACKPOT_SERVICE_KENO: lookupBoolean(CONST_VARS.REACT_APP_USE_JACKPOT_SERVICE_KENO),
    PADDED_ZEROS_LENGTH: lookupNumber(CONST_VARS.REACT_APP_PADDED_ZEROS_LENGTH, 10),
    USA_ONLY_ZIPCODE: lookupBoolean(CONST_VARS.REACT_APP_USA_ONLY_ZIPCODE),
    SHOW_TRANSACTION_ID: lookupBoolean(CONST_VARS.REACT_APP_SHOW_TRANSACTION_ID),
    IS_FETCH_DRAW_WINNERS_USING_DRAW_SERVICE: lookupBoolean(CONST_VARS.REACT_APP_IS_FETCH_DRAW_WINNERS_USING_DRAW_SERVICE),
    HIDE_REWARD_EARN_LIST_ICON: lookupBoolean(CONST_VARS.REACT_APP_HIDE_REWARD_EARN_LIST_ICON),
    SHOW_REWARD_CATEGORY_NAME: lookupBoolean(CONST_VARS.REACT_APP_SHOW_REWARD_CATEGORY_NAME),
    HIDE_DETAIL_TILE_CONTENT: lookupBoolean(CONST_VARS.REACT_APP_HIDE_DETAIL_TILE_CONTENT),
    TRIM_SQUARE_BRACKET_ACTIVITY_TITLE: lookupBoolean(CONST_VARS.REACT_APP_TRIM_SQUARE_BRACKET_ACTIVITY_TITLE),
    CHECK_TERMS_AND_CONDITIONS_ENABLED: lookupBoolean(CONST_VARS.REACT_APP_CHECK_TERMS_AND_CONDITIONS_ENABLED),
    SHOW_PENDING_POINTS_ON_HISTORY_PAGE: lookupBoolean(CONST_VARS.REACT_APP_SHOW_PENDING_POINTS_ON_HISTORY_PAGE),
    REFRESH_HISTORY_DATA_AFTER_GAMEPLAY: lookupBoolean(CONST_VARS.REACT_APP_REFRESH_HISTORY_DATA_AFTER_GAMEPLAY),
    HISTORY_WIDGET_PERSIST_SPINNER: lookupBoolean(CONST_VARS.REACT_APP_HISTORY_WIDGET_PERSIST_SPINNER),
    ACCESSIBLE_NUMBER_CHECKER_WIDGET: lookupBoolean(CONST_VARS.REACT_APP_ACCESSIBLE_NUMBER_CHECKER_WIDGET),
    PREFERENCES_MESSAGE_BAR_TIMEOUT_IN_MILLISECONDS: lookup(CONST_VARS.REACT_APP_PREFERENCES_MESSAGE_BAR_TIMEOUT_IN_MILLISECONDS) === 'null'
        ? null
        : lookupNumber(CONST_VARS.REACT_APP_PREFERENCES_MESSAGE_BAR_TIMEOUT_IN_MILLISECONDS, 10),
    ACCESSIBLE_PREFERENCE_SWITCH: lookupBoolean(CONST_VARS.REACT_APP_ACCESSIBLE_PREFERENCE_SWITCH),
    HIDE_SUCCESS_FOR_PENDING_ENTRIES: lookupBoolean(CONST_VARS.REACT_APP_HIDE_SUCCESS_FOR_PENDING_ENTRIES),
    SHOULD_NOT_SHOW_GAME_ID: lookupBoolean(CONST_VARS.REACT_APP_SHOULD_NOT_SHOW_GAME_ID),
    FASTPLAY_MANUAL_ENTRY: lookupBoolean(CONST_VARS.REACT_APP_FASTPLAY_MANUAL_ENTRY),
    FASTPLAY_GAMETYPE_ID: lookupNumber(CONST_VARS.REACT_APP_FASTPLAY_GAMETYPE_ID, 10)
};
var RemoteConstantsInternal = (function () {
    function RemoteConstantsInternal() {
        this.firebaseConfig = {
            apiKey: environment_variables_1.default.lookupString('REACT_APP_FIREBASE_API_KEY'),
            authDomain: environment_variables_1.default.lookupString('REACT_APP_FIREBASE_AUTH_DOMAIN'),
            databaseURL: environment_variables_1.default.lookupString('REACT_APP_FIREBASE_DATABASE_URL'),
            projectId: environment_variables_1.default.lookupString('REACT_APP_FIREBASE_PROJECT_ID'),
            storageBucket: environment_variables_1.default.lookupString('REACT_APP_FIREBASE_STORAGE_BUCKET'),
            messagingSenderId: environment_variables_1.default.lookupString('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
            appId: environment_variables_1.default.lookupString('REACT_APP_FIREBASE_APP_ID')
        };
        app_1.default.initializeApp(this.firebaseConfig);
        this.remoteConfig = app_1.default.remoteConfig();
        this.remoteConfig.settings = {
            minimumFetchIntervalMillis: 1800000,
            fetchTimeoutMillis: 10000
        };
        var defaultConfig = {};
        Object.keys(constants).forEach(function (key) {
            defaultConfig[key] = constants[key];
        });
        this.remoteConfig.defaultConfig = defaultConfig;
    }
    RemoteConstantsInternal.prototype.fetch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.remoteConfig.fetch()];
            });
        });
    };
    RemoteConstantsInternal.prototype.getValue = function (key) {
        return this.remoteConfig.getValue(key);
    };
    RemoteConstantsInternal.prototype.getBoolean = function (key) {
        return this.remoteConfig.getBoolean(key);
    };
    RemoteConstantsInternal.prototype.getNumber = function (key) {
        return this.remoteConfig.getNumber(key);
    };
    RemoteConstantsInternal.prototype.getString = function (key) {
        return this.remoteConfig.getString(key);
    };
    RemoteConstantsInternal.prototype.getJson = function (key) {
        return JSON.parse(this.remoteConfig.getString(key));
    };
    RemoteConstantsInternal.prototype.getValueSync = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.fetch()];
                    case 1:
                        _a.sent();
                        return [2, this.remoteConfig.getValue(key)];
                }
            });
        });
    };
    RemoteConstantsInternal.prototype.getStringSync = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.fetch()];
                    case 1:
                        _a.sent();
                        return [2, this.remoteConfig.getString(key)];
                }
            });
        });
    };
    RemoteConstantsInternal.prototype.sync = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.fetch()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    RemoteConstantsInternal.prototype.syncConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.remoteConfig.fetchAndActivate()];
            });
        });
    };
    return RemoteConstantsInternal;
}());
exports.RemoteConstants = new RemoteConstantsInternal();
exports.default = constants;
exports.NBSP = ' ';
//# sourceMappingURL=constants.js.map